import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Panel from '../../../../components/angle/Panel/index';
import logo from '../../../../assets/img/bsm-logo-single-white.png';
import 'parsleyjs';
import { formInputValidation } from '../../../../services/helper/form-helper';

import {
	login
} from '../../../../services/redux/authentication/actions';

class Login extends Component {
	constructor(props) {
		super(props);
		this.formRef = React.createRef();
		this.state = {
			userName: '',
			password: ''
		};
	}

	login = () => {
		let { login } = this.props;
		if (formInputValidation(this.formRef.current)) {
			login({
				userName: this.state.userName,
				password: this.state.password
			});
		}
	}

	handleInputChange = (event) => {
		const value = event.target.value;
		const name = event.target.name;
		this.setState({
			[name]: value
		});
	}

	onKeyPress = (e) => {
		if (e.key === 'Enter') {
			this.login();
		}
	}
	
	render() {
		let { user } = this.props;
		if (user) {
			return (
				<Redirect
					to={{
						pathname: '/'
					}}
				/>
			);
		}
		let loginButton = (
			<button
				type="button"
				className="btn btn-default btn-bordered pull-right"
				onClick={this.login}
			>
				Login
			</button>
		);

		const buttonList = [loginButton];

		return (
			<form ref={this.formRef} style={{margin: '0 auto', maxWidth: 320}}>
				<Panel showFooter footerComponents={buttonList}>
					<div style={{textAlign: 'center'}}>
						<img alt="logo" src={logo}/>
					</div>
					<div className="form-group col-md-12">
						<label>Username</label>
						<input
							className="form-control"
							type="text"
							name="userName"
							onChange={this.handleInputChange}
							onKeyPress={this.onKeyPress}
							autofocus
							data-parsley-required
						/>
					</div>
					<div className="form-group col-md-12">
						<label>Password</label>
						<input
							className="form-control"
							type="password"
							name="password"
							onChange={this.handleInputChange}
							onKeyPress={this.onKeyPress}
							data-parsley-required
						/>
					</div>
				</Panel>
			</form>
		);
	}
}
const mapStateToProps = state => ({
	user: state.authentication.user
});

const mapDispatchToProps = dispatch => 
	bindActionCreators({
		login
	}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(Login));



// WEBPACK FOOTER //
// ./src/screens/LoginPanel/Login/screens/index.js